// extracted by mini-css-extract-plugin
var _1 = "SubmissionForm_buttonsContainer__2ux+7";
var _2 = "SubmissionForm_container__OPQ9k";
var _3 = "SubmissionForm_errorContainer__RrxiC";
var _4 = "SubmissionForm_errorTextArea__yH4Jn";
var _5 = "SubmissionForm_generalSubtitle__sqQZ2";
var _6 = "SubmissionForm_infoContainer__UXY0T";
var _7 = "SubmissionForm_infoLight__52-hm";
var _8 = "SubmissionForm_paragraph__8ZTlP";
var _9 = "SubmissionForm_paragraphLight__dmM7q";
var _a = "SubmissionForm_productBrandName__-htaq";
var _b = "SubmissionForm_productImage__TdIrv";
var _c = "SubmissionForm_productName__YwaAI";
var _d = "SubmissionForm_productSummaryContainer__2bVOY";
var _e = "SubmissionForm_productTitleContainer__nBsxZ";
var _f = "SubmissionForm_secondaryTitle__XepL6";
var _10 = "SubmissionForm_starsContainer__OJjCA";
var _11 = "SubmissionForm_textArea__0BU3A";
var _12 = "SubmissionForm_title__8MD-g";
export { _1 as "buttonsContainer", _2 as "container", _3 as "errorContainer", _4 as "errorTextArea", _5 as "generalSubtitle", _6 as "infoContainer", _7 as "infoLight", _8 as "paragraph", _9 as "paragraphLight", _a as "productBrandName", _b as "productImage", _c as "productName", _d as "productSummaryContainer", _e as "productTitleContainer", _f as "secondaryTitle", _10 as "starsContainer", _11 as "textArea", _12 as "title" }
